// User-selectable Korean font. layout.scss reads var(--font-main); English words keep SpaceGrotesk.
// Web fonts other than the bundled KIMM load from jsDelivr only when picked; offline they fall back to the system font.
export const FONTS = [
  { id: 'kimm', label: '두벅체', family: "'KIMM'" },
  {
    id: 'pretendard', label: '프리텐다드', family: "'Pretendard Variable', 'Pretendard'",
    css: 'https://cdn.jsdelivr.net/gh/orioncactus/pretendard@v1.3.9/dist/web/variable/pretendardvariable-dynamic-subset.min.css',
  },
  {
    id: 'round', label: '둥근 고딕', family: "'NanumSquareRound'",
    css: 'https://cdn.jsdelivr.net/gh/innks/NanumSquareRound@1c6bf0ee5e0e17e2552311aac31ba157dcb805e8/nanumsquareround.min.css',
  },
  { id: 'system', label: '휴대폰 기본', family: "-apple-system, BlinkMacSystemFont, 'Apple SD Gothic Neo', 'Noto Sans KR', 'Malgun Gothic'" },
];

const KEY = 'font';

export const currentFont = () => {
  try { return localStorage.getItem(KEY) || 'kimm'; } catch (e) { return 'kimm'; }
};

// Load a font's stylesheet once (also used to preview every option on the picker)
export function loadFont(id) {
  const font = FONTS.find(f => f.id === id);
  if (!font || !font.css || document.getElementById(`font-${id}`)) return font;
  const link = document.createElement('link');
  link.id = `font-${id}`;
  link.rel = 'stylesheet';
  link.href = font.css;
  document.head.appendChild(link);
  return font;
}

export function applyFont(id = currentFont()) {
  const font = loadFont(id) || FONTS[0];
  document.documentElement.style.setProperty('--font-main', font.family);
  try { localStorage.setItem(KEY, font.id); } catch (e) { /* private mode: applies for this visit only */ }
}
